export const WORKSPACE_PINE_COMPOSE_START = "tessera:workspace-pine-compose-start";
export const WORKSPACE_PINE_COMPOSE_FAILED = "tessera:workspace-pine-compose-failed";
export const WORKSPACE_PINE_COMPOSE_REFRESH = "tessera:workspace-pine-compose-refresh";
export const WORKSPACE_PINE_ACTIVE_REMOVED = "tessera:workspace-pine-active-removed";
export const WORKSPACE_PINE_MASTER_SHOW = "tessera:workspace-pine-master-show";
export const WORKSPACE_PINE_ACTIVE_SHOW = "tessera:workspace-pine-active-show";
export const WORKSPACE_PINE_DOCK_VISIBILITY = "tessera:workspace-pine-dock-visibility";

export type WorkspacePineComposeEventDetail = {
  strategyId: string;
};

export type WorkspacePineDockVisibilityDetail = {
  strategyId: string;
  masterVisible: boolean;
  activeVisible: boolean;
};

function dispatchWorkspacePineComposeEvent(
  type: string,
  strategyId: string
): void {
  if (typeof window === "undefined") return;
  const id = strategyId.trim();
  if (!id) return;
  window.dispatchEvent(
    new CustomEvent<WorkspacePineComposeEventDetail>(type, {
      detail: { strategyId: id },
    })
  );
}

export function dispatchWorkspacePineComposeStart(strategyId: string): void {
  dispatchWorkspacePineComposeEvent(WORKSPACE_PINE_COMPOSE_START, strategyId);
}

export function dispatchWorkspacePineComposeFailed(strategyId: string): void {
  dispatchWorkspacePineComposeEvent(WORKSPACE_PINE_COMPOSE_FAILED, strategyId);
}

export function dispatchWorkspacePineComposeRefresh(strategyId: string): void {
  dispatchWorkspacePineComposeEvent(WORKSPACE_PINE_COMPOSE_REFRESH, strategyId);
}

export function dispatchWorkspacePineActiveRemoved(strategyId: string): void {
  dispatchWorkspacePineComposeEvent(WORKSPACE_PINE_ACTIVE_REMOVED, strategyId);
}

/** Reveal the Master Pinescript dock panel for a strategy sheet. */
export function dispatchWorkspacePineMasterShow(strategyId: string): void {
  dispatchWorkspacePineComposeEvent(WORKSPACE_PINE_MASTER_SHOW, strategyId);
}

/** Reveal the Active Pinescript dock panel for a strategy sheet. */
export function dispatchWorkspacePineActiveShow(strategyId: string): void {
  dispatchWorkspacePineComposeEvent(WORKSPACE_PINE_ACTIVE_SHOW, strategyId);
}

export function dispatchWorkspacePineDockVisibility(
  detail: WorkspacePineDockVisibilityDetail
): void {
  if (typeof window === "undefined") return;
  const strategyId = detail.strategyId.trim();
  if (!strategyId) return;
  window.dispatchEvent(
    new CustomEvent<WorkspacePineDockVisibilityDetail>(WORKSPACE_PINE_DOCK_VISIBILITY, {
      detail: {
        strategyId,
        masterVisible: detail.masterVisible,
        activeVisible: detail.activeVisible,
      },
    })
  );
}
